import { Component, OnInit } from '@angular/core';
import { PropertySearchResult } from '../../models/property-search-result.model';
import { AssetService } from 'src/app/core/services/http/agency-mgmt/asset.service';
import { AssetCategoryCount } from '../../models/asset-category-count.model';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { EventService } from 'src/app/core/services/http/event.service';
import { Events } from 'src/app/shared/constants/events.constant';
@Component({
  selector: 'app-asset-dashboard',
  templateUrl: './asset-dashboard.component.html',
  styleUrls: ['./asset-dashboard.component.scss']
})
export class AssetDashboardComponent implements OnInit {

  public openSidebar: boolean = false;
  public property: PropertySearchResult = <PropertySearchResult>{};
  public isGetAssetCountByCatergoryLoading = false;
  public assetCategoryCount: AssetCategoryCount = <AssetCategoryCount>{};
  public isAssetViewClosed : boolean = false;
    constructor(
        private assetService: AssetService,
        private router: Router,
        private location: Location,
        private eventService: EventService) { }
  ngOnInit(): void {
    this.getAssetCounts();

    this.eventService.events.subscribe((event) => {
      if (Events.RefreshAssetCountEvent == event) {
        this.getAssetCounts();
      }
    });

  }

  onPropertySelect(property: PropertySearchResult) {
    
    this.isAssetViewClosed = false;
    this.property = property;
  }

  getAssetCounts() {
    this.isGetAssetCountByCatergoryLoading = true;
    this.assetCategoryCount = null;
    this.assetService.getAssetCategoryCount()
      .subscribe({
        next: (result) => {
          this.assetCategoryCount = result;
          this.isGetAssetCountByCatergoryLoading = false;
        },
        error: () => {
          this.isGetAssetCountByCatergoryLoading = false;
        }
      })
  }
  closeFilteredAssetsByProperty(){
    this.property = null;
    this.isAssetViewClosed = true;
    this.getAssetCounts();
  }
  viewAction(assetCategory: string) {
    this.router.navigate(['/asset/actionable-asset/', assetCategory]);
  }

  dismiss(){
    this.location.back();
  }
}
